module.exports = __webpack_public_path__ + "img/bg-black.89eba6e7.png";